import { getDefault } from '@/hooks/useGridView/utils';
import type { GridView } from '@/hooks/useGridView/utils';
import type { UserScreenerGqlResponse } from '@/hooks/useGridView/useGqlUserScreener';

export const transformUserScreenerGqlData = (
  rawGqlData: UserScreenerGqlResponse
): GridView => {
  const rawData = rawGqlData?.userScreener;
  if (!rawData) {
    return getDefault();
  }

  return {
    id: String(rawData.id),
    name: rawData.name,
    rules: rawData.filterJson,
    slug: rawData.slug,
    modifyDate: Number(rawData.modifyDate),
    description: rawData.description,
    pageDescription: rawData.pageDescription,
    imageUrl: rawData.imageUrl,
    onlyMarketFiltered: rawData.onlyMarketFiltered,
    typeSlug: rawData.type.slug,
    crawlable: !rawData.status,
  };
};
